// extracted by mini-css-extract-plugin
export var blog = "hero-module--blog--J1PhN";
export var bluFirst = "hero-module--bluFirst--vV9yV";
export var bluSecond = "hero-module--bluSecond--D+NuI";
export var bluShard = "hero-module--bluShard--w9F-a";
export var bluThird = "hero-module--bluThird--xCBNG";
export var borealisSVG = "hero-module--borealisSVG--M65tI";
export var buttonContainer = "hero-module--buttonContainer--tAHGP";
export var contact = "hero-module--contact--iAXqA";
export var defau1t = "hero-module--defau1t--GfBlk";
export var details = "hero-module--details--uX001";
export var donationPathSVG = "hero-module--donationPathSVG--HB8t3";
export var donor = "hero-module--donor--dpElV";
export var donorInfo = "hero-module--donorInfo--bNfZq";
export var efforts = "hero-module--efforts--KoR5w";
export var eop = "hero-module--eop--NEppC";
export var eopIcons = "hero-module--eopIcons--AIGZC";
export var formContainer = "hero-module--formContainer--qUwLV";
export var gImgWrapper = "hero-module--gImgWrapper--tdrbL";
export var give = "hero-module--give--r42i6";
export var grnFirst = "hero-module--grnFirst--uzz7v";
export var grnSecond = "hero-module--grnSecond--MQtIR";
export var grnShard = "hero-module--grnShard--ZV7bG";
export var grnThird = "hero-module--grnThird--W0ZQK";
export var hero = "hero-module--hero--4Tbuw";
export var heroButton = "hero-module--heroButton--7OrY2";
export var heroButtonRight = "hero-module--heroButtonRight--poyCD";
export var heroScrollTrigger = "hero-module--heroScrollTrigger--BKBfR";
export var interactive = "hero-module--interactive--EzPbp";
export var left = "hero-module--left---NrwP";
export var message = "hero-module--message--1XOm-";
export var partners = "hero-module--partners--J3dmr";
export var pictureGrid = "hero-module--pictureGrid--NfSxo";
export var pillars = "hero-module--pillars---F0H6";
export var pioneer = "hero-module--pioneer--WUD6C";
export var right = "hero-module--right--bujHz";
export var scholarships = "hero-module--scholarships--7AFWx";
export var shard = "hero-module--shard--QaDzB";
export var spacer = "hero-module--spacer--DdKaN";
export var textBlock = "hero-module--textBlock--LWE0u";
export var toolTipBox = "hero-module--toolTipBox--Tjvm+";
export var toolTipGroup = "hero-module--toolTipGroup--2DRGW";
export var toolTipPoint = "hero-module--toolTipPoint--4n8ia";
export var toolTipPointer = "hero-module--toolTipPointer--GM2Dz";
export var toolTipText = "hero-module--toolTipText--FjfW4";